<template>
  <div class="trysee-catalog-list">
    <template v-for="(item, index) in list">
      <li
        class="item"
        :key="index"
        :class="{
          'video': item.lesson_type === LESSON_TYPE.video,
          'audio': item.lesson_type === LESSON_TYPE.voice,
          'current': +$route.params.lesson_id === item.id,
          'playing': isPlaying && +$route.params.lesson_id === item.id,
        }"
        @click.stop="jumpToLesson(item)"
      >
        <div class="name">{{ item.name }}</div>
        <div class="duration">{{ item.video_duration | durationStr }}</div>
      </li>
    </template>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { LESSON_TYPE } from '@/common/js/config';

export default {
  props: {
    // 课程列表
    list: {
      type: Array,
      default: () => ([])
    },
    // 设置item的背景颜色
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    // 课程状态, 0创建中，1待审核，2已发布，3不通过，4下架，5隐藏
    lessonState: {
      type: Number,
      default: 0
    },
    seriesId: {
      type: Number,
      default: 0
    },
    lessonIsPlaying: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    durationStr(duration) {
      const minute = Math.floor(duration / 60) < 10 ? `0${Math.floor(duration / 60)}` : Math.floor(duration / 60);
      const seconds = duration % 60 < 10 ? `0${Math.floor(duration % 60)}` : Math.floor(duration % 60);
      return `${minute}:${seconds}`;
    }
  },
  data() {
    return {
      LESSON_TYPE,
      isPlaying: false
    };
  },
  watch: {
    lessonIsPlaying: {
      handler(nVal) {
        this.isPlaying = nVal;
      },
      deep: true
    }
  },
  methods: {
    jumpToLesson(data) {
      if (+this.$route.params.lesson_id === data.id) {
        return;
      }
      if (this.lessonState === 4) {
        Toast('训练营已下架，无法试看');
      } else if (data.lesson_type === LESSON_TYPE.video || data.lesson_type === LESSON_TYPE.voice) {
        this.$router.push({
          name: 'camp-try-see',
          params: {
            lesson_id: data.id,
          },
          query: {
            lt: data.lesson_type,
            sid: this.seriesId,
            t: +new Date()
          }
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';
.trysee-catalog-list {
  // border-radius 4px

  .item {
    position relative
    width 100%
    padding 16px 16px 18px 52px
    .name {
      font-size: 15px;
      font-weight: 400;
      color: $color-text;
      line-height: 20px;
      multi-line(2)
    }
    .duration {
      width 100%
      margin-top 8px
      // padding-left 16px
      // background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAP1BMVEUAAAB/f3+ZmZmqqqqXl5eXl5eampqZmZmXl5eampqZmZmZmZmYmJiampqZmZmZmZmZmZmZmZmZmZmZmZmZmZnid9SVAAAAFHRSTlMAAgUJNkBRVVt5f4qapNjc6Ony9jKbOJkAAACSSURBVCjPnZHbDoQgDERHEAG5Cfj/37obINaaYLLblyE9pJcp8G8IHWIpMWjB81vK3ihlfE7bLb24amV/SlvdcgF3rPRrPdxVp4783kkd1USy48fZxaY+gc6SA5l10+DBAXxoEs0TmNikqCdQ5Qb28xscUCnwUtQcvDmNCz4uLQi+IFkCbsncxLnt00O9nPaH+ABOkQYlUR8GVwAAAABJRU5ErkJggg==') center left no-repeat
      background-size 12px
      font-size: 12px;
      font-weight: 300;
      color: #999999;
      line-height: 12px;
    }
    &::before {
      content ''
      display block
      position absolute
      top 24px
      left 16px
      width 24px
      height 24px
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAilBMVEUAAAAAAAAAAAAgICAXFxcaGhoYGBgXFxcXFxcWFhYcHBwbGxsYGBgYGBgaGhoYGBgXFxcaGhoaGhoaGhoZGRkaGhoZGRkYGBgYGBgZGRkZGRkZGRkZGRkYGBgaGhoZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkYGBgZGRkZGRkZGRkZGRkZGRkZGRkihYc7AAAALXRSTlMAAwYICxQVFiEiJDk/QERKV1hiY2hten5/hZikqrKzxMrNztfa6+/x8/j5/f6OrXxbAAABNUlEQVRIx+2V21qDMBCEU5CmFa1FgSIHAREUyP/+r+eVLaGkNb3u3u2ww7eZ3UyEuMdNsQmzuu37ts7CzfXqVVAqjqHKYHW5ftcwi2Z3odxNFTAUkS8dR/pRMQAqdU316wroEu+EeEkHVGtDfQPkUgdlDjSLDLeCMT7H4xGqpa5SGPdLf9qPkC7ooyBe7jUGdabVqoHcpEYOzXweAXTSRJAdBDOshIN5QAmUOrJVDJ6Z4A0ofa9CKCbp06ujMwoINSCDaJL+8PWifY8g04Aa/EkK8PE4AXyoNUILckagf3846QStRujBmRPg8wg40P+DUJsJ1i1ZH3om6/dVWWeDe367Njjr1RAlJDbLZ7/e1hfI+oram4C9zVgb2Z9VHqZWebhklfZmbG/3NzwoQgixtXqy7rEUv1i5PlGq261dAAAAAElFTkSuQmCC') center no-repeat
      background-size cover
    }
    // &.video {
    //   &::before {
    //     background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAilBMVEUAAAAAAAAAAAAgICAXFxcaGhoYGBgXFxcXFxcWFhYcHBwbGxsYGBgYGBgaGhoYGBgXFxcaGhoaGhoaGhoZGRkaGhoZGRkYGBgYGBgZGRkZGRkZGRkZGRkYGBgaGhoZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkYGBgZGRkZGRkZGRkZGRkZGRkZGRkihYc7AAAALXRSTlMAAwYICxQVFiEiJDk/QERKV1hiY2hten5/hZikqrKzxMrNztfa6+/x8/j5/f6OrXxbAAABNUlEQVRIx+2V21qDMBCEU5CmFa1FgSIHAREUyP/+r+eVLaGkNb3u3u2ww7eZ3UyEuMdNsQmzuu37ts7CzfXqVVAqjqHKYHW5ftcwi2Z3odxNFTAUkS8dR/pRMQAqdU316wroEu+EeEkHVGtDfQPkUgdlDjSLDLeCMT7H4xGqpa5SGPdLf9qPkC7ooyBe7jUGdabVqoHcpEYOzXweAXTSRJAdBDOshIN5QAmUOrJVDJ6Z4A0ofa9CKCbp06ujMwoINSCDaJL+8PWifY8g04Aa/EkK8PE4AXyoNUILckagf3846QStRujBmRPg8wg40P+DUJsJ1i1ZH3om6/dVWWeDe367Njjr1RAlJDbLZ7/e1hfI+oram4C9zVgb2Z9VHqZWebhklfZmbG/3NzwoQgixtXqy7rEUv1i5PlGq261dAAAAAElFTkSuQmCC') center no-repeat
    //     background-size cover
    //   }
    // }
    // &.audio {
    //   &::before {
    //     background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAnFBMVEUAAACqqqp/f3+ZmZmLi4uVlZWdnZ2bm5uXl5eenp6Xl5ednZ2ZmZmYmJiZmZmbm5uYmJiampqZmZmYmJiYmJiZmZmYmJiZmZmZmZmZmZmZmZmampqZmZmampqampqZmZmampqampqZmZmZmZmZmZmZmZmYmJiZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZksG7mgAAAAM3RSTlMAAwYKCwwNFxsdICIoLzI4PklLVFxwcoKKkZacp6uwsbW2w8jNztjc4ufq7vL09vn7/P5w+64EAAAA6UlEQVRIx+2SyxqBUBSFU5RQQrl2UZRcilrv/24mfRR7lwEjrdn+z/rPYJ8jCG3+NtJsvTtdr6fdeiZ9UO+vLnjksuo39ecJ8v3CUERRMRb7HMm8tt5zgK3+nPUt4PT4vhziPK2i6RmhzPU7PqLhKxxG8DuMsMRx8E4HRyzpvnbLxhQfZzeNFFxs6Js2cCmsZqlCC0qaqQS2YHPbsGER1IPJCSY8gh4w4oQRDgRN0OWELhKC5uC/AHIK1gn4mjCJ40kZFjMvxEBchsXMC0D1rJi/IwQBLwQBvw5SqNvfrwVmrXyYh2vTpjl3s6YktWUP6XgAAAAASUVORK5CYII=') center no-repeat
    //     background-size cover
    //   }
    // }
    &.current {
      &::before {
        background url(../../common/images/catalog_icon_loading@2x.png) center no-repeat
        background-size cover
      }
      .name {
        color $color-theme
      }
      &.playing {
        &::before {
          background url(../../common/images/catalog_icon_playing.gif) center no-repeat
          background-size cover
        }
      }
    }

  }
}
</style>
